export default __webpack_public_path__ + "static/03-2d1c852c98bc5b1fd986b55f1e9a221a.jpg";